var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    viewBox: "0 0 20 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75697 13.903C6.49178 13.9029 6.23747 13.7975 6.04997 13.61L0.732971 8.29199C0.5455 8.10446 0.440186 7.85016 0.440186 7.58499C0.440186 7.31983 0.5455 7.06552 0.732971 6.87799C0.825844 6.78501 0.936128 6.71127 1.05753 6.66095C1.17892 6.61063 1.30906 6.58472 1.44048 6.58472C1.57189 6.58472 1.70201 6.61063 1.82341 6.66095C1.94481 6.71127 2.05509 6.78501 2.14796 6.87799L6.75697 11.489L17.857 0.389008C18.0445 0.201537 18.2988 0.0962219 18.564 0.0962219C18.8291 0.0962219 19.0834 0.201537 19.271 0.389008C19.4584 0.576535 19.5638 0.830844 19.5638 1.09601C19.5638 1.36117 19.4584 1.61548 19.271 1.80301L7.47098 13.603C7.37789 13.698 7.26679 13.7734 7.1442 13.8249C7.0216 13.8764 6.88995 13.903 6.75697 13.903Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.7e6c2f025848835a578b42dfcd7d3411.svg";
export { ForwardRef as ReactComponent };